export enum FeatureToggleStates {
  Disabled = 'Disabled',
  Managers = 'Managers',
  OpenToAll = 'OpenToAll',
}
